// extracted by mini-css-extract-plugin
export default {"skip":"Buttons_skip__Ns39d"};